var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvitationImage = function SvgInvitationImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "24 18 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_109_26997)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 18H70.8L96 32.4V90H49.2L24 75.6V18Z",
    fill: "#E0C2A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6505 36.154C58.427 36.0518 59.2118 36 60 36C60.0008 36 60.0015 36 60.0023 36C60.0108 36 60.0192 36 60.0277 36C60.8066 36.0012 61.5821 36.053 62.3495 36.154C63.9057 36.3589 65.4319 36.7669 66.8883 37.3702C66.9335 37.3889 66.9787 37.4078 67.0238 37.4269C67.7 37.7135 68.36 38.0421 69 38.4115C70.3594 39.1964 71.6132 40.1574 72.7279 41.2721C74.3994 42.9435 75.7252 44.9278 76.6298 47.1117C77.5344 49.2956 78 51.6362 78 54C78 56.3638 77.5344 58.7044 76.6298 60.8883C75.7252 63.0722 74.3994 65.0565 72.7279 66.7279C71.6132 67.8426 70.3594 68.8036 69 69.5885C68.3174 69.9826 67.6119 70.3301 66.8883 70.6298C65.4319 71.2331 63.9057 71.6411 62.3495 71.846C61.573 71.9482 60.7882 72 60 72C59.2118 72 58.427 71.9482 57.6505 71.846L58.1204 68.2768C58.7416 68.3586 59.3694 68.4 60 68.4C60.6306 68.4 61.2584 68.3586 61.8796 68.2768C63.1246 68.1129 64.3455 67.7865 65.5106 67.3039C66.0895 67.0641 66.6539 66.7861 67.2 66.4708C68.2875 65.8429 69.2906 65.0741 70.1823 64.1823C71.5195 62.8452 72.5802 61.2577 73.3039 59.5106C74.0275 57.7636 74.4 55.891 74.4 54C74.4 52.109 74.0275 50.2364 73.3039 48.4894C72.5802 46.7423 71.5195 45.1548 70.1823 43.8177C69.2906 42.9259 68.2875 42.1571 67.2 41.5292C66.6539 41.2139 66.0895 40.9359 65.5106 40.6961C64.3455 40.2135 63.1246 39.8871 61.8796 39.7232C61.2584 39.6414 60.6306 39.6 60 39.6C59.3694 39.6 58.7416 39.6414 58.1204 39.7232L57.6505 36.154Z",
    fill: "#864C13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1117 37.3702C52.3881 37.6699 51.6826 38.0174 51 38.4115C50.3174 38.8057 49.6636 39.2429 49.0423 39.7196L51.2338 42.5757C51.7309 42.1943 52.2539 41.8445 52.8 41.5292C53.3461 41.2139 53.9105 40.9359 54.4894 40.6961L53.1117 37.3702Z",
    fill: "#864C13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4115 45C44.8057 44.3174 45.2429 43.6636 45.7196 43.0423L48.5757 45.2338C48.1943 45.7309 47.8445 46.2539 47.5292 46.8C47.2139 47.3461 46.9359 47.9105 46.6961 48.4894L43.3702 47.1117C43.6699 46.3881 44.0174 45.6826 44.4115 45Z",
    fill: "#864C13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.154 51.6505C42.0518 52.427 42 53.2118 42 54C42 54.7882 42.0518 55.573 42.154 56.3495L45.7232 55.8796C45.6414 55.2584 45.6 54.6306 45.6 54C45.6 53.3694 45.6414 52.7416 45.7232 52.1204L42.154 51.6505Z",
    fill: "#864C13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4115 63C44.0174 62.3174 43.6699 61.6119 43.3702 60.8883L46.6961 59.5106C46.9359 60.0895 47.2139 60.6539 47.5292 61.2C47.8445 61.7461 48.1943 62.2691 48.5757 62.7662L45.7196 64.9577C45.2429 64.3364 44.8057 63.6826 44.4115 63Z",
    fill: "#864C13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0423 68.2804C49.6636 68.7571 50.3174 69.1943 51 69.5885C51.6826 69.9826 52.3881 70.3301 53.1117 70.6298L54.4894 67.3039C53.9105 67.0641 53.3461 66.7861 52.8 66.4708C52.2539 66.1555 51.7309 65.8057 51.2338 65.4243L49.0423 68.2804Z",
    fill: "#864C13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2 54V45H61.8V53.2544L67.5728 59.0272L65.0272 61.5728L58.7272 55.2728C58.3896 54.9352 58.2 54.4774 58.2 54Z",
    fill: "#864C13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_109_26997",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.501961 0 0 0 0 0.12549 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_109_26997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_109_26997",
    result: "shape"
  })))));
};
export { SvgInvitationImage as ReactComponent };
export default __webpack_public_path__ + "assets/6e6fd3a5.svg";